module.exports = __webpack_public_path__ + "img/account_circle-24px.13f1017b.svg";